module.exports = __webpack_public_path__ + "static/img/pro3_tab5.2bdddc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab5.jpg
// module id = ycFj
// module chunks = 171